import { forwardRef } from "react";
import style from "./BoldMenu.module.scss";
import ArrowIcon from "../../../public/remove_back/menu/menu_arrow.svg";
import AdaptiveArrow from "../../../public/remove_back/menu/bold_menu_arrow.svg";
import { useRef, useEffect } from "react";
import { HandySvg } from "handy-svg";

// eslint-disable-next-line  react/display-name
const BoldMenu = forwardRef((props, ref) => {
	const { dictionary, isMobile, stepType = null, btn = [], onContinue = () => {}, onBackBtn = () => {}, onNewBtn = () => {}, pageTitle, fileType } = props;
	const title = useRef(null);
	useEffect(() => {
		if (window.innerWidth <= 480 && window.innerWidth < window.innerHeight) {
			return;
		}
		setTimeout(() => {
			if (title.current !== null) {
				title.current.scrollIntoView();
			}
		}, 100);
	}, [title, isMobile]);

	let header = pageTitle === "turn" ? dictionary["Turn photo into video"] : dictionary["page title"];

	return (
		<div ref={ref}>
			<div className={style.head}>
				{stepType === null && <h1 ref={title} className="page_title" dangerouslySetInnerHTML={{ __html: `${header}` }} />}
				{stepType === "choose_bg" && (
					<p ref={title} className={style.screenName}>
						{dictionary["Choose background"]}
					</p>
				)}
				{stepType === "editor" && (
					<p ref={title} className={style.screenName} id="editor-title">
						{dictionary[`Edit ${fileType === "video" ? fileType : "photo"}`]}
					</p>
				)}
				{(stepType === "loading" || stepType === "download") && <h1 ref={title} className="page_title" dangerouslySetInnerHTML={{ __html: `${dictionary["page title"]}` }} />}
			</div>

			<div className={style.menu}>
				{btn.includes("back") && (
					<button onClick={onBackBtn} className={style["menu-back"]}>
						<ArrowIcon className={style.backIcon} />
						<AdaptiveArrow className={style["adaptive-arrow"]} />
						<span className={style["btn-text"]}>{dictionary["editor"]["Back"]}</span>
					</button>
				)}

				<div className={style.adaptive}>
					{stepType === "choose_bg" && <p className={style["screenName"]}>{dictionary["Choose background"]}</p>}
					{stepType === "editor" && <p className={style["screenName"]}>{dictionary[`Edit ${fileType === "video" ? fileType : "photo"}`]}</p>}
				</div>

				{btn.includes("continue") && (
					<button id="continue-btn" onClick={onContinue} className={style["menu-continue"]}>
						<span className={style["btn-text"]}>{dictionary["Continue"]}</span>
						<ArrowIcon className={style.continueIcon} />
						<AdaptiveArrow className={`${style["adaptive-arrow"]} ${style.continue}`} />
					</button>
				)}

				{btn.includes("newFile") && (
					<label className={style["menu-new"]} htmlFor="video_file">
						<input
							className={style.input}
							onChange={(event) => onNewBtn(event.target.files)}
							type="file"
							id="video_file"
							accept={`.mp4,.mov, .mkv, video/mp4, .webm, .jpg, .jpeg, .png, image/png, image/jpeg`}
							poster="/video/remove_bg_preview.png"
						/>
						<HandySvg src={"/remove_back/menu/new_file_icon.svg"} width={24} height={24} className={style.newIcon} fill="transparent" />
						<span className={style["btn-text"]}>{dictionary["new_file"] || "New file"}</span>
					</label>
				)}
			</div>
		</div>
	);
});

export default BoldMenu;
